import { dataTruck } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTruck = /*#__PURE__*/createIcon(dataTruck)
export default IconTruck
